<template>
	<div>
		<b-container>
			<b-breadcrumb :items="breadcrumb" style="margin-top: 15px;"></b-breadcrumb>
			<b-row style="margin: 10px 0px 10px 0px; padding: 0px;">
				<b-col cols="2" style="padding-left:0px;">
					<b-input-group class="mb-3">
						<b-form-input
							id="example-input"
							v-model="attendanceTime"
							type="time"
							placeholder="HH:mm"
						></b-form-input>
						<b-input-group-append>
							<b-form-timepicker
								v-model="attendanceTime"
								button-only
								right
								minutes-step="30"
								aria-controls="example-input"
							></b-form-timepicker>
						</b-input-group-append>
					</b-input-group>
				</b-col>
				<b-col cols="2">
					<date-pick v-model="attendanceDate" :format="dateFormat" :input-attributes="{ class: 'form-control' }" :weekdays="$lang.weekDays" :months="$lang.months" :is-date-disabled="disableDate"></date-pick>
				</b-col>
				<b-col cols="3" style="padding-left:0px;">
					<b-button variant="outline-primary" block class="title" @click="processAttendance('checkIn')" :disabled="selected.length == 0"> {{$lang.attendance.checkInTime}}</b-button>
				</b-col>
				<b-col cols="3" style="padding-left:0px;">
					<b-button variant="outline-danger" block class="title" @click="processAttendance('checkOut')" :disabled="selected.length == 0"> {{$lang.attendance.checkOutTime}}</b-button>
				</b-col>
			</b-row>

			<b-alert variant="danger" :show="validAttendance == false" dismissible>
				{{ this.attendanceErrorMessage }}
			</b-alert>

			<b-table
				selectable
				striped
				hover
				outlined
				ref="selectableTable"
				:items="dailyAttendance"
				:fields="fields"
				:busy="isBusy"
				@row-selected="onRowSelected"
			>
				<template v-slot:cell(index)="data">
					{{ data.index + 1 }}
				</template>

				<template v-slot:cell(name)="data">
					{{ data.item.firstName + ' ' + data.item.lastName }}
				</template>

				<template v-slot:cell(selected)="{ rowSelected }">
					<template v-if="rowSelected">
						<span aria-hidden="true">&check;</span>
						<span class="sr-only">Selected</span>
					</template>
					<template v-else>
						<span aria-hidden="true">&nbsp;</span>
						<span class="sr-only">Not selected</span>
					</template>
				</template>

				<template v-slot:cell(attendance.permit)="data">
					<p-check class="p-switch p-fill" color="info" v-model="data.item.attendancePermit" >{{data.item.attendancePermit == true ? 'Sí' : 'No'}}</p-check>
				</template>

				<template v-slot:head(selected)="data">
					<span @click="toggleAll" style="cursor:pointer">{{ data.label }}</span>
				</template>

				<template v-slot:cell(attendance.checkInTime)="data">
					{{ data.item.attendance.checkInTime }}
				</template>

				<template v-slot:table-busy>
					<div class="text-center text-info my-2">
						<b-spinner class="align-middle"></b-spinner>
						&nbsp;<strong>{{$lang.common.loading}}</strong>
					</div>
				</template>

			</b-table>
		</b-container>
	</div>

</template>

<script>
import { mapState } from 'vuex'
import { dateFormat, timeFormat, formatTime } from '../../utils.js'
import moment from 'moment'
import DatePick from 'vue-date-pick'

export default {
	data() {
		return {
			fields: [
				{key: 'index', label: '#'},
				{
					key: 'selected', label: 'Select'
				},
				{
					key: 'name',
					label: this.$lang.worker.name
				},
				{
					key: 'contract.position.name',
					label: this.$lang.contract.position
				},
				{
					key: 'attendance.checkInTime',
					label: this.$lang.attendance.checkInTime,
				},
				{
					key: 'attendance.checkOutTime',
					label: this.$lang.attendance.checkOutTime
				},
				{
					key: 'attendance.permit',
					label: this.$lang.attendance.permit
				}
			],
			breadcrumb: [{'text': this.$lang.worker.moduleName,'to': '/'},{'text': this.$lang.worker.list,'href': '#'}],
			attendance: {},
			selectedAll: false,
			selected: [],
			validAttendance: true,
			attendanceDate: moment().format(dateFormat),
			attendanceTime: moment().format(timeFormat),
			weekDays: [],
			dailyAttendance: [],
			dateFormat: dateFormat,
			timeFormat: timeFormat,
			isBusy: false,
			attendanceErrorMessage: ''
		}
	},
	components: { DatePick },
	computed: {
		...mapState(['currentUser']),
	},
	methods: {
		toggleAll() {
			if (this.selectedAll) {
				this.selectedAll = false
				this.$refs.selectableTable.clearSelected()
			} else {
				this.selectedAll = true
				this.$refs.selectableTable.selectAllRows()
			}
		},
		checkClass() {
			console.log(1)
		},
		onRowSelected(items) {
			this.selected = items
		},
		disableDate(date) {
			return moment().subtract(1,'days').unix() >= moment(date).unix();
		},
		processAttendance(attendanceType) {
			this.$Progress.start()
			this.toggleBusy()
			let attendanceRecords = []
			this.validAttendance = true

			this.selected.forEach((worker) => {
				let attendance = {}
				attendance.workerId = worker.id
				attendance.permit = worker.attendancePermit || false
				attendance.attendanceDate = this.attendanceDate
				attendance.costCenterId = worker.contract.costCenter.id
				worker.validAttendance = true


				if (worker.attendance.id) {
					attendance.id = worker.attendance.id
				}

				if (attendanceType == 'checkIn') {
					if(worker.attendance.checkInTime != 'N/A') {
						worker.validAttendance = false
						this.validAttendance = false
						this.attendanceErrorMessage = this.$lang.errors.invalidAttendance + ' ' + this.$lang.common.for.toLowerCase() + ' ' + this.$lang.attendance.checkInTime.toLowerCase();
					} else {
						attendance.checkInTime = formatTime(this.attendanceTime)
						attendance.checkOutTime = (worker.attendance.checkOutTime) ? worker.attendance.checkOutTime : 'N/A'
					}
				}
				if (attendanceType == 'checkOut') {
					if(worker.attendance.checkOutTime != 'N/A') {
						worker.validAttendance = false
						this.validAttendance = false
						this.attendanceErrorMessage = this.$lang.errors.invalidAttendance + ' ' + this.$lang.common.for.toLowerCase() + ' ' + this.$lang.attendance.checkOutTime.toLowerCase();
					} else {
						attendance.checkOutTime = formatTime(this.attendanceTime)
						attendance.checkInTime = (worker.attendance.checkInTime) ? worker.attendance.checkInTime : 'N/A'
					}
				}

				attendanceRecords.push(attendance)

			})
			// console.log(attendanceRecords)
			if(this.validAttendance) {
				this.$store.dispatch('createAttendance', attendanceRecords)
				this.fetchAttendance(this.attendanceDate)
			} else {
				this.$Progress.finish();
				this.toggleBusy()
			}
			console.log(this.selected)
		},
		fetchAttendance(date) {
			this.$store.dispatch('fetchAttendance', {date}).then(() => {
				this.dailyAttendance = this.$store.getters.dailyAttendance
				this.$Progress.finish();
				this.toggleBusy()
			})
		},
		toggleBusy() {
			this.isBusy = !this.isBusy
		}
	},
	watch: {
		attendanceDate: function(value) {
			this.fetchAttendance(value)
		}
	},
	beforeMount() {
		this.$Progress.start()
		this.toggleBusy()
	},
	created() {
		this.fetchAttendance(this.attendanceDate)
	},
}

</script>